"use strict";
exports.__esModule = true;
exports.GdcExecution = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @public
 */
var GdcExecution;
(function (GdcExecution) {
    function isAttributeHeaderItem(header) {
        return !isEmpty_1["default"](header) && header.attributeHeaderItem !== undefined;
    }
    GdcExecution.isAttributeHeaderItem = isAttributeHeaderItem;
    function isMeasureHeaderItem(header) {
        return !isEmpty_1["default"](header) && header.measureHeaderItem !== undefined;
    }
    GdcExecution.isMeasureHeaderItem = isMeasureHeaderItem;
    function isTotalHeaderItem(header) {
        return !isEmpty_1["default"](header) && header.totalHeaderItem !== undefined;
    }
    GdcExecution.isTotalHeaderItem = isTotalHeaderItem;
    function isAttributeHeader(header) {
        return !isEmpty_1["default"](header) && header.attributeHeader !== undefined;
    }
    GdcExecution.isAttributeHeader = isAttributeHeader;
    function isMeasureGroupHeader(header) {
        return !isEmpty_1["default"](header) && header.measureGroupHeader !== undefined;
    }
    GdcExecution.isMeasureGroupHeader = isMeasureGroupHeader;
})(GdcExecution = exports.GdcExecution || (exports.GdcExecution = {}));
//# sourceMappingURL=GdcExecution.js.map